// extracted by mini-css-extract-plugin
export default {"root":"o1YdTl","text":"m8w0Kv"};